import gql from 'graphql-tag';

/**
 * Query to fetch all available campaign types for advertising submissions.
 *
 * @returns Campaign types with their ID, name, and cost
 * @usedIn Campaign checkout (CheckoutForm), AdForm
 */
export const CAMPAIGN_TYPES = gql`
  query campaignTypes {
    campaignTypes {
      typeId
      name
      cost
    }
  }
`;
